<template>
  <a-config-provider :locale="locale">
    <div id="app" :class="{ 'app-version-notice-open': versionNoticeVisible }">
      <app-version-notice @change="handleVersionNoticeChange" />
      <keep-alive :include="include" :max="20">
        <router-view :key="$route.path" />
      </keep-alive>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import AppVersionNotice from '@/components/app-version-notice/AppVersionNotice.vue'
export default {
  name: 'App',
  components: {
    AppVersionNotice,
  },
  data() {
    return {
      locale: zhCN,
      versionNoticeVisible: false,
    };
  },
  computed: {
    include() {
      const { openTab } = this.$store.state.tabStore;
      const openTabData = openTab.map(data=>data.name).filter(data=>data!="" && data!=null);
      return openTabData;
    },
  },
  created() {
    this.resize();
    window.removeEventListener("resize", this.resize);
    window.addEventListener("resize", this.resize);
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    /**
     * 同步新版本提示展示状态，用顶部留白保证提示条不遮挡页面内容。
     *
     * @param {boolean} visible 新版本提示是否可见
     * @returns {void}
     */
    handleVersionNoticeChange(visible) {
      this.versionNoticeVisible = visible;
    },
    resize() {
      const windowWidth = window.innerWidth;
      this.$store.commit("setWindowWidth", windowWidth);
    },
  },
}
</script>

<style lang="less">
@import "assets/less/common";

#app {
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  &.app-version-notice-open {
    padding-top: 44px;
  }
  //font-family: Avenir, Helvetica, Arial, sans-serif;
  //-webkit-font-smoothing: antialiased;
  //-moz-osx-font-smoothing: grayscale;
  &>div:not(.app-version-notice){
    height: 100%;
  }
}
.ant-calendar-range{
		width: 100vw !important;
		max-width: 570px;
	}
</style>
